// extracted by mini-css-extract-plugin
export default {"backToTop":"BackToTop_backToTop__VMZJS","show":"BackToTop_show__t7uBg"};